import { Wrap as ChakraWrap, forwardRef, WrapProps } from '@chakra-ui/react';

/**
 Wrap is a layout component used to add space between elements and wraps automatically if there isn't enough space.
 */
export const Wrap = forwardRef((props: WrapProps, ref) => {
  const { children, ...otherProps } = props;
  return (
    <ChakraWrap ref={ref} {...otherProps}>
      {children}
    </ChakraWrap>
  );
});

export { WrapItem } from '@chakra-ui/react';
